module.exports = __webpack_public_path__ + "static/media/animation2.0b0b2e14.mp4";